"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
const GeneralConstants_1 = require("../../Utilities/Constants/GeneralConstants");
class ColumnInternalApi extends ApiBase_1.ApiBase {
    /**
     * Retrieves 'ColumnType' property for a given Column
     *   isCumulativeAggregate(input: string): boolean {
     *     return !!this.getNodesFromExpression(input, 'CUMUL')?.length;
     *   }
     * @param columnId Column to use
     */
    getAgGridColumnType(columnId) {
        return this.adaptable.getAgGridColumnType(columnId);
    }
    /**
     * Retrieves a list providing the Friendly Name / Caption for all columns
     */
    getAllColumnFriendlyNames() {
        return this.getColumnApi()
            .getColumns()
            .map((c) => {
            return c.friendlyName;
        });
    }
    /**
     * Retrieves AG Grid's field property for the column
     * @param columnId columnId to look up
     */
    getAgGridColumnFieldForAdaptableColumn(columnId) {
        const agGridColumn = this.getAgGridColumnForAdaptableColumn(columnId);
        return agGridColumn.getColDef().field || '';
    }
    /**
     * Retrieves AG Grid's column for an Adaptable column
     * @param columnId columnId to look up
     */
    getAgGridColumnForAdaptableColumn(columnId) {
        return this.adaptable.getAgGridColumnForColumnId(columnId);
    }
    isActionRowButtonColumn(columnId) {
        return columnId === GeneralConstants_1.ADAPTABLE_ROW_ACTION_BUTTONS;
    }
}
exports.ColumnInternalApi = ColumnInternalApi;
